import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRectangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormRectangle"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormRectangle;
